import PageHeader from '../molecules/PageHeader';
import EditIcon from '@mui/icons-material/Edit';
import { MenuItem, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import SectionBox from '../atoms/SectionBox';
import RegistrationDateSelector from '../molecules/RegistrationDateSelector';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FormSubmissionButtons from '../molecules/FormSubmissionButtons';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Button } from '@mui/material';

const EditStudentDetailLayout = ({
  studentDetail,
  handleFormUpdate,
  handleDateFormatting,
  handleFormSubmission,
  loading,
  handleDocDeletion,
  handleFileUpload,
  clearDate,
}) => {
  const test = () => {
    console.log(studentDetail);
  };

  const MiniCTAButton = ({ children }) => {
    return (
      <div className='cursor-pointer rounded-md border border-primary-200 py-8 text-center duration-300 hover:bg-primary-100'>
        {children}
      </div>
    );
  };

  const generateDocLink = type => {
    let docMarker = false;
    const docLink = studentDetail?.documents?.map(doc => {
      if (doc.document_type === type) {
        docMarker = true;
        return (
          <div key={`${type}-doc`}>
            {doc.document_name}
            <HighlightOffIcon
              fontSize='small'
              color='error'
              onClick={() => handleDocDeletion(doc.document_name, type)}
            />
          </div>
        );
      }
    });

    if (!docMarker) {
      return (
        <Button variant='contained' component='label' id='uploadButton'>
          Upload <UploadFileIcon fontSize='small' />
          <input
            hidden
            type='file'
            id={`uploadButton=${type}`}
            onChange={e => handleFileUpload(e, type)}
          />
        </Button>
      );
      // <button className=' text-primary-700'>
      //   Upload <UploadFileIcon fontSize='small' />
      //   <input hidden type='file' id='fileUpload' onChange='' />
      // </button>
    }
    return docLink;
  };

  const priParent = studentDetail?.parents?.[0];
  const secParent = studentDetail?.parents?.[1];

  return (
    <div>
      <PageHeader
        backLink={
          <Link
            id='back-link-text'
            to={`/manage/students/${studentDetail?.student_id}`}
            className='flex'
            data-cy='back-to-student-detail-link'
          >
            <ArrowBackIosNewIcon /> Back to Student Details
          </Link>
        }
      >
        {studentDetail?.student_first_name}&nbsp;
        {studentDetail?.student_last_name} <EditIcon onClick={test} />
      </PageHeader>

      <SectionBox title='Personal ID'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* ID TYPE */}
          <div className='col-span-6 md:col-span-1'>
            <TextField
              label='ID Type'
              id='student_id_type'
              select
              name='student_id_type'
              fullWidth
              value={studentDetail?.student_id_type ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'id-type-select' }}
            >
              <MenuItem value='bc'>BC</MenuItem>
              <MenuItem value='fin'>FIN</MenuItem>
            </TextField>
          </div>

          {/* ID */}
          <div className='col-span-6 md:col-span-2'>
            <TextField
              label='ID Number'
              fullWidth
              name='student_id_number'
              value={studentDetail.student_id_number ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'id-number-field' }}
            />
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Name Format'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* FIRST NAME */}
          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='First Name'
              fullWidth
              name='student_first_name'
              value={studentDetail.student_first_name ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'first-name-field' }}
            />
          </div>

          {/* LAST NAME */}
          <div className='col-span-6 md:col-span-3'>
            <TextField
              label='Last Name'
              fullWidth
              name='student_last_name'
              value={studentDetail.student_last_name ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'last-name-field' }}
            />
          </div>
          {/* BC NAME */}
          <div className='col-span-6'>
            <TextField
              label='BC Name'
              fullWidth
              name='student_bc_name'
              value={studentDetail.student_bc_name ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'bc-name-field' }}
            />
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Date Of Birth'>
        {/* DOB */}
        <div className=' md:w-3/4'>
          <RegistrationDateSelector
            dateObjSetter={handleDateFormatting}
            setDate={studentDetail?.student_dob}
            setName='student_dob'
            testid='dob'
          />
        </div>
      </SectionBox>

      <SectionBox title='Address'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* ADDRESS */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              label='Address'
              name='student_address'
              fullWidth
              value={studentDetail.student_address ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'address-field' }}
            />
          </div>
          {/* ADDRESS UNIT */}
          <div className='col-span-6 md:col-span-2 md:col-start-1'>
            <TextField
              label='Unit'
              name='student_address_unit'
              fullWidth
              value={studentDetail.student_address_unit ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'address-unit-field' }}
            />
          </div>
          {/* POSTAL CODE */}
          <div className='col-span-6 md:col-span-2'>
            <TextField
              label='Postal Code'
              name='student_address_postal'
              fullWidth
              value={studentDetail.student_address_postal ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'address-postal-field' }}
            />
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Mobile'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* MOBILE */}
          <div className='col-span-6 md:col-span-3'>
            <TextField
              label='Mobile Number'
              name='student_mobile'
              fullWidth
              value={studentDetail.student_mobile ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'mobile-field' }}
            />
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Gender'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* GENDER */}
          <div className='col-span-6 md:col-span-3 md:col-start-1'>
            <TextField
              label='Gender'
              name='student_gender'
              select
              fullWidth
              value={studentDetail.student_gender ?? ''}
              onChange={handleFormUpdate}
              id='student_gender'
            >
              <MenuItem value='M'>Male</MenuItem>
              <MenuItem value='F'>Female</MenuItem>
            </TextField>
          </div>
        </div>
      </SectionBox>

      <SectionBox title='School'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* SCHOOL */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              fullWidth
              name='student_school'
              label='School'
              value={studentDetail?.student_school ?? ''}
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'school-field' }}
            />
          </div>

          {/* SCHOOL LEVEL */}
          <div className='col-span-6 md:col-span-4 md:col-start-1'>
            <TextField
              fullWidth
              name='student_school_level'
              label='School Level'
              value={studentDetail?.student_school_level ?? ''}
              onChange={handleFormUpdate}
              helperText='Please enter full level details. Eg: Primary 2, Secondary 1'
              inputProps={{ 'data-cy': 'school-level-field' }}
            />
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Catechism'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* CAT LEVEL */}
          <div className='col-span-6 md:col-span-4 md:col-start-1'>
            <TextField
              fullWidth
              name='student_level'
              label='Cat Level'
              value={studentDetail?.student_level ?? ''}
              onChange={handleFormUpdate}
              helperText='1 - 10'
              inputProps={{ 'data-cy': 'cat-level-field' }}
            />
          </div>

          {/* PREFERRED SESSION */}
          <div className='col-span-6 md:col-span-4 md:col-start-1'>
            <TextField
              fullWidth
              name='student_preferred_session_time'
              label='Preferred Session'
              value={studentDetail?.student_preferred_session_time ?? ''}
              select
              onChange={handleFormUpdate}
              id='student_preferred_session_time'
            >
              <MenuItem></MenuItem>
              {studentDetail?.sessions?.map(session => {
                return (
                  <MenuItem key={`pref-${session.id}`} value={session.id}>
                    {session.session}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          {/* CAT SESSION */}
          <div className='col-span-6 md:col-span-4 md:col-start-1'>
            <TextField
              fullWidth
              name='student_session_time'
              label='Cat Session'
              value={studentDetail?.student_session_time ?? ''}
              select
              onChange={handleFormUpdate}
              id='student_session_time'
            >
              <MenuItem></MenuItem>
              {studentDetail?.sessions?.map(session => {
                return (
                  <MenuItem key={session.id} value={session.id}>
                    {session.session}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
        </div>
      </SectionBox>

      <SectionBox title='Baptism'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* BAPTISM DATE */}
          <div className='col-span-6'>
            <RegistrationDateSelector
              dateObjSetter={handleDateFormatting}
              setDate={studentDetail?.student_baptism_date}
              setName='student_baptism_date'
              testid='baptism'
            />
            <div
              className='col-span-6 text-xs text-red-600'
              onClick={() => clearDate('bt')}
            >
              Clear Date
            </div>
          </div>

          {/* BAPTISM CHURCH */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              fullWidth
              select
              name='student_baptism_church'
              label='Baptism Church'
              value={studentDetail.student_baptism_church ?? ''}
              onChange={handleFormUpdate}
              id='student_baptism_church'
            >
              <MenuItem>&nbsp;</MenuItem>
              {studentDetail?.churches?.map(church => {
                return (
                  <MenuItem key={church.church_id} value={church.church_id}>
                    {church.church_name}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>

          {/* BAPTISM CHURCH OVERSEAS */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              name='student_baptism_church_ovr'
              label='Baptism Overseas'
              value={studentDetail.student_baptism_church_ovr ?? ''}
              fullWidth
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'baptism-church-ovrseas-field' }}
            />
          </div>

          <div className='col-span-6'>
            <p className='my-4 font-bold'>Document</p>
            {generateDocLink('bt')}
          </div>
        </div>
      </SectionBox>

      <SectionBox title='First Reconciliation'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* FIRST RECON DATE */}
          <div className='col-span-6'>
            <RegistrationDateSelector
              dateObjSetter={handleDateFormatting}
              setDate={studentDetail?.student_first_recon_date}
              setName='student_first_recon_date'
              testid='recon'
            />
            <div
              className='col-span-6 text-xs text-red-600'
              onClick={() => clearDate('fr')}
            >
              Clear Date
            </div>
          </div>

          {/* FIRST RECON CHURCH */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              fullWidth
              select
              name='student_first_recon_church'
              label='First Reconciliation Church'
              value={studentDetail.student_first_recon_church ?? ''}
              onChange={handleFormUpdate}
              id='student_first_recon_church'
            >
              <MenuItem>&nbsp;</MenuItem>
              {studentDetail?.churches?.map(church => {
                return (
                  <MenuItem key={church.church_id} value={church.church_id}>
                    {church.church_name}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>

          {/* FIRST RECON CHURCH OVERSEAS */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              name='student_first_recon_church_ovr'
              label='First Reconciliation Overseas'
              value={studentDetail.student_first_recon_church_ovr ?? ''}
              fullWidth
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'recon-church-overseas-field' }}
            />
          </div>

          <div className='col-span-6'>
            <p className='my-4 font-bold'>Document</p>
            {generateDocLink('fr')}
          </div>
        </div>
      </SectionBox>

      <SectionBox title='First Holy Communion'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          {/* FIRST HOLY COMM DATE */}
          <div className='col-span-6'>
            <RegistrationDateSelector
              dateObjSetter={handleDateFormatting}
              setDate={studentDetail?.student_holy_comm_date}
              setName='student_holy_comm_date'
              testid='holycomm'
            />
            <div
              className='col-span-6 text-xs text-red-600'
              onClick={() => clearDate('hc')}
            >
              Clear Date
            </div>
          </div>

          {/* FIRST HOLY COMM CHURCH */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              fullWidth
              select
              name='student_holy_comm_church'
              label='First Holy Comm Church'
              value={studentDetail.student_holy_comm_church ?? ''}
              onChange={handleFormUpdate}
              id='student_holy_comm_church'
            >
              <MenuItem>&nbsp;</MenuItem>
              {studentDetail?.churches?.map(church => {
                return (
                  <MenuItem key={church.church_id} value={church.church_id}>
                    {church.church_name}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>

          {/* FIRST HOLY COMM CHURCH OVERSEAS */}
          <div className='col-span-6 md:col-span-4'>
            <TextField
              name='student_holy_comm_church_ovr'
              label='First Holy Comm Overseas'
              value={studentDetail.student_holy_comm_church_ovr ?? ''}
              fullWidth
              onChange={handleFormUpdate}
              inputProps={{ 'data-cy': 'holy-comm-church-overseas-field' }}
            />
          </div>

          <div className='col-span-6'>
            <p className='my-4 font-bold'>Document</p>
            {generateDocLink('hc')}
          </div>
        </div>
      </SectionBox>

      {/* STUDENT NOTES */}
      <SectionBox title='Student Notes'>
        <textarea
          name='student_notes'
          value={studentDetail?.student_notes}
          className='h-36 w-full border p-2'
          onChange={handleFormUpdate}
        ></textarea>
      </SectionBox>

      <SectionBox title='Parental Information'>
        <div className='grid grid-cols-6 gap-4 md:w-3/4'>
          <div className='col-span-3'>
            {/* PRIMARY PARENT */}
            <Link
              to={`/manage/parents/edit/${priParent?.parent_id}`}
              reloadDocument
            >
              <MiniCTAButton>Update Primary Parent</MiniCTAButton>
            </Link>
          </div>

          <div className='col-span-3'>
            {/* SECONDARY PARENT */}
            <Link
              to={
                secParent
                  ? `/manage/parents/edit/${secParent?.parent_id}`
                  : `/manage/parents/add/${studentDetail?.student_id}`
              }
              reloadDocument
            >
              <MiniCTAButton>
                {secParent ? 'Update Secondary Parent' : 'Add Secondary Parent'}
              </MiniCTAButton>
            </Link>
          </div>
        </div>
      </SectionBox>

      <FormSubmissionButtons
        cancelURL={`/manage/students/${studentDetail.student_id}`}
        submissionHandler={handleFormSubmission}
        loadStatus={loading}
      />
    </div>
  );
};

export default EditStudentDetailLayout;
